import React, { useState, useEffect } from 'react';
import { UserCheck } from 'lucide-react';
import ModalShell from './ModalShell';

const initialForm = {
  name: '',
  employeeId: '',
  phone: '',
  email: '',
  designation: '',
};

const StaffModal = ({ isOpen, onClose, onSubmit, editingStaff }) => {
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    if (isOpen) {
      if (editingStaff?.id) {
        setFormData({
          name: editingStaff.name ?? '',
          employeeId: editingStaff.employeeId ?? editingStaff.employee_id ?? '',
          phone: editingStaff.phone ?? '',
          email: editingStaff.email ?? '',
          designation: editingStaff.designation ?? editingStaff.position ?? '',
        });
      } else {
        setFormData(initialForm);
      }
    }
  }, [isOpen, editingStaff]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name?.trim()) return;

    onSubmit({
      name: formData.name.trim(),
      employeeId: formData.employeeId?.trim(),
      phone: formData.phone?.trim(),
      email: formData.email?.trim(),
      designation: formData.designation?.trim(),
    });
  };

  if (!isOpen) return null;

  return (
    <ModalShell
      title={editingStaff?.id ? 'Edit Staff Member' : 'Add Staff Member'}
      subtitle="Manage team member details"
      icon={UserCheck}
      onClose={onClose}
      footer={(
        <>
          <button type="button" onClick={handleSubmit} className="ui-btn-primary flex-1">
            {editingStaff?.id ? 'Update Staff' : 'Add Staff Member'}
          </button>
          <button type="button" onClick={onClose} className="ui-btn-secondary flex-1">
            Cancel
          </button>
        </>
      )}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="ui-label">Full Name *</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            className="ui-input"
            placeholder="Enter full name"
            required
          />
        </div>
        <div>
          <label className="ui-label">Employee ID</label>
          <input
            type="text"
            value={formData.employeeId}
            onChange={(e) => handleInputChange('employeeId', e.target.value)}
            className="ui-input"
            placeholder="e.g. EMP001"
          />
        </div>
        <div>
          <label className="ui-label">Phone Number</label>
          <input
            type="text"
            value={formData.phone}
            onChange={(e) => handleInputChange('phone', e.target.value)}
            className="ui-input"
            placeholder="e.g. 9876543210"
          />
        </div>
        <div>
          <label className="ui-label">Email</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
            className="ui-input"
            placeholder="staff@example.com"
          />
        </div>
        <div>
          <label className="ui-label">Designation</label>
          <input
            type="text"
            value={formData.designation}
            onChange={(e) => handleInputChange('designation', e.target.value)}
            className="ui-input"
            placeholder="e.g. Store Manager"
          />
        </div>
      </form>
    </ModalShell>
  );
};

export default StaffModal;
